import { render } from "./AgreeModal.vue?vue&type=template&id=cbcf1fb8"
import script from "./AgreeModal.vue?vue&type=script&lang=js"
export * from "./AgreeModal.vue?vue&type=script&lang=js"

import "./AgreeModal.vue?vue&type=style&index=0&id=cbcf1fb8&lang=css"

import exportComponent from "/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__